export const STATES = [
    {
        state_id: 2,
        state_name_en: 'ANDHRA PRADESH',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'AP',
        category: '2',
        lgd_code: '28',
        state_code: '02',
        kyc_flag: '2',
    },
    {
        state_id: 3,
        state_name_en: 'ARUNACHAL PRADESH',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'AR',
        category: '1',
        lgd_code: '12',
        state_code: '03',
        kyc_flag: '2',
    },
    {
        state_id: 4,
        state_name_en: 'ASSAM',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'AS',
        category: '2',
        lgd_code: '18',
        state_code: '04',
        kyc_flag: '2',
    },
    {
        state_id: 5,
        state_name_en: 'BIHAR',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'BH',
        category: '2',
        lgd_code: '10',
        state_code: '05',
        kyc_flag: '2',
    },
    {
        state_id: 31,
        state_name_en: 'CHHATTISGARH',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'CG',
        category: '2',
        lgd_code: '22',
        state_code: '33',
        kyc_flag: '2',
    },
    {
        state_id: 35,
        state_name_en: 'LADAKH',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'LD',
        category: '4',
        lgd_code: '37',
        state_code: '37',
        kyc_flag: '2',
    },
    {
        state_id: 8,
        state_name_en: 'GOA',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'GO',
        category: '4',
        lgd_code: '30',
        state_code: '10',
        kyc_flag: '2',
    },
    {
        state_id: 9,
        state_name_en: 'GUJARAT',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'GJ',
        category: '2',
        lgd_code: '24',
        state_code: '11',
        kyc_flag: '2',
    },
    {
        state_id: 10,
        state_name_en: 'HARYANA',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'HR',
        category: '3',
        lgd_code: '6',
        state_code: '12',
        kyc_flag: '2',
    },
    {
        state_id: 11,
        state_name_en: 'HIMACHAL PRADESH',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'HP',
        category: '3',
        lgd_code: '2',
        state_code: '13',
        kyc_flag: '2',
    },
    {
        state_id: 12,
        state_name_en: 'JAMMU AND KASHMIR',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'JK',
        category: '3',
        lgd_code: '1',
        state_code: '14',
        kyc_flag: '2',
    },
    {
        state_id: 32,
        state_name_en: 'JHARKHAND',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'JH',
        category: '2',
        lgd_code: '20',
        state_code: '34',
        kyc_flag: '2',
    },
    {
        state_id: 13,
        state_name_en: 'KARNATAKA',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'KN',
        category: '2',
        lgd_code: '29',
        state_code: '15',
        kyc_flag: '2',
    },
    {
        state_id: 14,
        state_name_en: 'KERALA',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'KR',
        category: '2',
        lgd_code: '32',
        state_code: '16',
        kyc_flag: '2',
    },
    {
        state_id: 17,
        state_name_en: 'LAKSHADWEEP',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'LA',
        category: '4',
        lgd_code: '31',
        state_code: '19',
        kyc_flag: '2',
    },
    {
        state_id: 15,
        state_name_en: 'MADHYA PRADESH',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'MP',
        category: '2',
        lgd_code: '23',
        state_code: '17',
        kyc_flag: '2',
    },
    {
        state_id: 16,
        state_name_en: 'MAHARASHTRA',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'MH',
        category: '2',
        lgd_code: '27',
        state_code: '18',
        kyc_flag: '2',
    },
    {
        state_id: 18,
        state_name_en: 'MANIPUR',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'MN',
        category: '1',
        lgd_code: '14',
        state_code: '20',
        kyc_flag: '2',
    },
    {
        state_id: 19,
        state_name_en: 'MEGHALAYA',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'MG',
        category: '1',
        lgd_code: '17',
        state_code: '21',
        kyc_flag: '2',
    },
    {
        state_id: 20,
        state_name_en: 'MIZORAM',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'MZ',
        category: '1',
        lgd_code: '15',
        state_code: '22',
        kyc_flag: '2',
    },
    {
        state_id: 21,
        state_name_en: 'NAGALAND',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'NG',
        category: '1',
        lgd_code: '13',
        state_code: '23',
        kyc_flag: '2',
    },
    {
        state_id: 22,
        state_name_en: 'ODISHA',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'OR',
        category: '2',
        lgd_code: '21',
        state_code: '24',
        kyc_flag: '2',
    },
    {
        state_id: 24,
        state_name_en: 'PUNJAB',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'PJ',
        category: '3',
        lgd_code: '3',
        state_code: '26',
        kyc_flag: '2',
    },
    {
        state_id: 25,
        state_name_en: 'RAJASTHAN',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'RJ',
        category: '2',
        lgd_code: '8',
        state_code: '27',
        kyc_flag: '2',
    },
    {
        state_id: 26,
        state_name_en: 'SIKKIM',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'SK',
        category: '1',
        lgd_code: '11',
        state_code: '28',
        kyc_flag: '2',
    },
    {
        state_id: 27,
        state_name_en: 'TAMIL NADU',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'TN',
        category: '2',
        lgd_code: '33',
        state_code: '29',
        kyc_flag: '2',
    },
    {
        state_id: 34,
        state_name_en: 'TELANGANA',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'TS',
        category: '2',
        lgd_code: '36',
        state_code: '36',
        kyc_flag: '2',
    },
    {
        state_id: 28,
        state_name_en: 'TRIPURA',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'TR',
        category: '1',
        lgd_code: '16',
        state_code: '30',
        kyc_flag: '2',
    },
    {
        state_id: 33,
        state_name_en: 'UTTARAKHAND',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'UT',
        category: '3',
        lgd_code: '5',
        state_code: '35',
        kyc_flag: '2',
    },
    {
        state_id: 29,
        state_name_en: 'UTTAR PRADESH',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'UP',
        category: '2',
        lgd_code: '9',
        state_code: '31',
        kyc_flag: '2',
    },
    {
        state_id: 30,
        state_name_en: 'WEST BENGAL',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'WB',
        category: '2',
        lgd_code: '19',
        state_code: '32',
        kyc_flag: '2',
    },
    {
        state_id: 1,
        state_name_en: 'ANDAMAN AND NICOBAR',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'AN',
        category: '4',
        lgd_code: '35',
        state_code: '01',
        kyc_flag: '2',
    },
    {
        state_id: 23,
        state_name_en: 'PUDUCHERRY',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'PO',
        category: '4',
        lgd_code: '34',
        state_code: '25',
        kyc_flag: '2',
    },
    {
        state_id: 36,
        state_name_en: 'DNH AND DAMAN DIU',
        state_name_hi: 'NULL',
        state_name_local: 'NULL',
        state_short_name_en: 'DN',
        category: '4',
        lgd_code: '38',
        state_code: '38',
        kyc_flag: '2',
    },
    {
        state_id: 91,
        state_name_en: 'DEVELOPMENT',
        state_name_hi: 'DEVELOPMENT',
        state_name_local: 'DEVELOPMENT',
        state_short_name_en: 'demo-uat',
        category: '4',
        lgd_code: '00',
        state_code: '00',
        kyc_flag: '2',
    },
    {
        state_id: 92,
        state_name_en: 'DEMO & TRAINING',
        state_name_hi: 'DEMO & TRAINING',
        state_name_local: 'DEMO & TRAINING',
        state_short_name_en: 'demo-uat',
        category: '4',
        lgd_code: '00',
        state_code: '00',
        kyc_flag: '2',
    },
];
